import { createVNode as e, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ZoomInOutlinedStandard.js";
import m from "../components/PfIcon.js";
const t = (o, r) => {
  const n = {
    ...o,
    ...r.attrs
  };
  return e(m, a(n, {
    icon: d
  }), null);
};
t.displayName = "ZoomInOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
